angular.module('assets')
    .controller('AssetDocumentDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, AssetDocument, AssetStorage, AssetService, Numeration, AssetSettingsLoader) {
        let vm = this;
        vm.AssetService = AssetService;
        vm.activeTab = data.id ? 1 : 0;
        vm.item = angular.copy(data);
        vm.storageFilters = {
            project: data.sourceProject
        };

        if (!vm.item.id) {
            Numeration.nextNumber({clazz: "pl.multisoft.modules.assets.document.AssetDocument"}).$promise.then(result => {
                vm.item.number = result.number;
            });
        }

        vm.supervisorAcceptOnRevise = true;
        AssetSettingsLoader.isSupervisor().then(isSupervisor => vm.isUserSupervisor = isSupervisor);

        vm.toggleAll = () => {
            let selectedItems = vm.storageItems.list.filter(i => i.selected === true);
            let selectedAny = selectedItems.length > 0 && selectedItems.length !== vm.storageItems.list.length;
            let selectedNone = selectedItems.length === 0;
            if (selectedAny || selectedNone) {
                vm.storageItems.list
                    .filter(i => i.selected !== true)
                    .forEach(i => {
                        i.selected = true;
                        vm.afterSelect(i);
                    });
            } else {
                vm.storageItems.list
                    .filter(i => i.selected === true)
                    .forEach(i => {
                        i.selected = false;
                        vm.afterSelect(i);
                    });
            }

        };

        vm.removeSelected = (asset, $idx) => {
            vm.item.items.splice($idx, 1);
            vm.storageItems.list
                .filter(i => i.asset.id === asset.id)
                .forEach(i => i.selected = false);
            vm.checkIfSelectedAll();
        };

        vm.checkIfSelectedAll = () => {
            let selectedItems = vm.storageItems.list.filter(i => i.selected === true);
            vm.selectedAll = selectedItems.length > 0 && selectedItems.length === vm.storageItems.list.length;
        };

        vm.afterSelect = item => {
            if (item.selected) {
                vm.item.items.push({asset: item.asset});
            } else {
                let idx = vm.item.items.findIndex(i => i.asset.id === item.asset.id);
                vm.item.items.splice(idx, 1);
            }
            vm.checkIfSelectedAll();
        };

        vm.isSelected = it => {
            let idx = vm.item.items.findIndex(i => i.asset.id === it.asset.id);
            return idx !== -1;
        };

        vm.loadStorage = () => {
            delete vm.storageItems;
            if (vm.item.type !== 'IN' && !vm.storageFilters.project) {
                vm.storageItems = [];
                return;
            }
            let params = angular.copy(vm.storageFilters);
            params.project = (params && params.project) ? params.project.id : null;
            AssetStorage.list(params).$promise
                .then(response => {
                    response.list.forEach(i => {
                        i.selected = vm.isSelected(i);
                    });
                    vm.storageItems = response;
                    vm.storageFilters.page = response.pageNumber;
                    vm.storageFilters.fullListSize = response.fullListSize;
                    vm.storageFilters.objectsPerPage = response.objectsPerPage;
                    vm.checkIfSelectedAll();
                });
        };

        vm.onProjectChanged = project => {
            switch (vm.item.type) {
                case "TRANSFER":
                case "OUT":
                    vm.storageFilters.project = project;
                    break;
            }
            vm.loadStorage();
        };

        vm.reset = () => {
            delete vm.storageFilters.search;
            vm.loadStorage();
        };
        vm.loadStorage();

        vm.cancel = () => $uibModalInstance.dismiss('Canceled');

        vm.save = () => {
            var onSaveSuccess = function (result) {
                $rootScope.$broadcast('asset-doc.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            };
            var onSaveError = function () {
            };

            if (vm.item.id !== null) {
                if (vm.item.revised) {
                    if (vm.supervisorAcceptOnRevise === false) {
                        return AssetDocument.reviseNoAccept(vm.item, onSaveSuccess, onSaveError).$promise;
                    }
                    return AssetDocument.revise(vm.item, onSaveSuccess, onSaveError).$promise;
                }
            } else {
                return AssetDocument.save(vm.item, onSaveSuccess, onSaveError).$promise;
            }
        };

        $scope.$on('asset.updated', () => vm.loadStorage());
    })
